(() => {
  const llEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  // Preserve links to variants from the temporarily combined product.
  const legacyVariants = {
    '45617306173549': ['4d-makura-lattice-3000', '50505080307821'],
    '45824541687917': ['4d-makura-lattice-3000-black', '50505080340589'],
    '45694196645997': ['4d-makura-lattice-3000-black', '50505080373357'],
    '45824553418861': ['4d-makura-lattice-3000-light-pink', '50505080406125'],
    '45824560234605': ['4d-makura-lattice-3000-light-pink', '50505080438893']
  };
  const legacy = legacyVariants[new URLSearchParams(location.search).get('variant')];
  if (document.querySelector('.ll-pillow-colors') && legacy) {
    const target = new URL(location.href);
    target.pathname = `${llEnglish ? '/en' : ''}/products/${legacy[0]}`;
    target.searchParams.set('variant', legacy[1]);
    location.replace(target.href);
    return;
  }
  const money = (cents) => new Intl.NumberFormat(llEnglish ? 'en-JP' : 'ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(cents / 100);

  document.querySelectorAll('[data-ll-product]').forEach((root) => {
    const variantsNode = root.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const fields = [...root.querySelectorAll('[data-option-position]')];
    const idInput = root.querySelector('.product-variant-id');
    const addButton = root.querySelector('.ll-pdp__add');
    const priceNodes = root.querySelectorAll('[data-product-price], [data-sticky-price]');
    const forcedSoldOutValue = (root.dataset.forcedSoldOutValue || '').trim();
    const isExternalCampaign = root.dataset.externalCampaign === 'true';
    const isPurchasable = (variant) => variant.available && !(forcedSoldOutValue && variant.options.includes(forcedSoldOutValue));
    // Existing combinations remain selectable even when out of stock.
    const isSelectable = (variant) => !(forcedSoldOutValue && variant.options.includes(forcedSoldOutValue));

    const update = () => {
      fields.forEach((field, index) => {
        const selectedBefore = fields.map((item) => item.querySelector('[data-option-value]:checked')?.value || '');
        field.querySelectorAll('[data-option-value]').forEach((choice) => {
          const isAvailable = variants.some((variant) => (
            isSelectable(variant)
            && variant.options[index] === choice.value
            && variant.options.slice(0, index).every((option, previousIndex) => option === selectedBefore[previousIndex])
          ));
          choice.setAttribute('aria-disabled', String(!isAvailable));
          choice.disabled = !isAvailable;
          if (isAvailable) choice.removeAttribute('tabindex');
          else choice.setAttribute('tabindex', '-1');
          const hasStock = variants.some((variant) => isPurchasable(variant)
            && variant.options[index] === choice.value
            && variant.options.slice(0, index).every((option, previousIndex) => option === selectedBefore[previousIndex]));
          const label = choice.closest('.ll-pdp__choice');
          label?.classList.toggle('is-sold-out', !hasStock && !isExternalCampaign);
          label?.classList.toggle('is-selectable', isAvailable);
          if (label) label.title = `${choice.value}${!hasStock && !isExternalCampaign ? (llEnglish ? ' (Sold out)' : '（売り切れ）') : ''}`;
          const exists = variants.some((variant) => variant.options[index] === choice.value
            && variant.options.slice(0, index).every((option, previousIndex) => option === selectedBefore[previousIndex]));
          choice.closest('.ll-pdp__choice')?.classList.toggle('is-unavailable', !exists);
        });
        const checked = field.querySelector('[data-option-value]:checked');
        if (!checked || checked.getAttribute('aria-disabled') === 'true') {
          const fallback = field.querySelector('[data-option-value]:not([aria-disabled="true"])');
          if (fallback) fallback.checked = true;
        }
      });
      const selected = fields.map((field) => field.querySelector('[data-option-value]:checked')?.value || '');
      fields.forEach((field) => {
        const label = field.querySelector('[data-selected-label]');
        const checked = field.querySelector('[data-option-value]:checked');
        if (label && checked) label.textContent = checked.value;
      });
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) {
        if (idInput) idInput.disabled = true;
        if (addButton) {
          addButton.disabled = true;
          addButton.querySelector('[data-add-label]').textContent = (llEnglish ? 'Sold out' : '売り切れ');
        }
        return;
      }
      const isAvailable = isPurchasable(variant);
      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = !isAvailable;
      }
      priceNodes.forEach((node) => {
        if (node.matches('[data-product-price]')) node.innerHTML = `${money(variant.price)} <small>${llEnglish ? '(tax included)' : '（税込）'}</small>`;
        else node.textContent = money(variant.price);
      });
      if (addButton) {
        addButton.disabled = !isAvailable;
        addButton.querySelector('[data-add-label]').textContent = isAvailable ? (llEnglish ? 'Add to cart' : 'カートに入れる') : (llEnglish ? 'Sold out' : '売り切れ');
      }
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      if (variant.featured_media) root.querySelector(`[data-media-target="${variant.featured_media.id}"]`)?.click();
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-value]')) update();
    });

    root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-media-id]').forEach((media) => media.classList.toggle('is-hidden', media.dataset.mediaId !== button.dataset.mediaTarget));
      root.querySelectorAll('[data-media-target]').forEach((item) => item.classList.toggle('is-active', item === button));
    }));

    root.querySelector('[data-scroll-to-buy]')?.addEventListener('click', () => {
      root.querySelector('[data-variant-selectors]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    const quantity = root.querySelector('input[name="quantity"]');
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });

    update();
  });
})();
